import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Button, Input, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import PermissionWrapper from '../../../auth/PermissionWrapper';
import * as utilities from '../../../utilities';
import Marketing2ActionsModal from '../../Marketing2/Marketing2ActionsModal';
import CompanyContext from '../../../auth/CompanyContext';
class LandingToDos extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);
    this.state = {
      toDos: [],
      users: [],
      isLoading: false,
      selectedUser: this.props.user,
    }
    this.openActionsModal = null;
    this.closeActionsModal = null;
  }

  componentDidMount = () => {
    this.getMarketingToDos();
    if (this.checkPermission('View Other User Todos')) this.getUsers();
  };

  checkPermission = (permission) => {
    return permission === '' || permission == null ||
      this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
  }

  getUsers = () => {
    fetch('/api/users/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        this.setState({
          users: results.data.filter(user => user.Auth0.indexOf('000000') === -1),
        });
      });

  }

  getMarketingToDos = (cb) => {
    this.setState({
      isLoading: true
    }, () => {
      fetch(`/api/marketing2ComponentsCompanies/${this.state.selectedUser}`, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + this.props.clientToken,
          'X-Database': this.context.company
        }
      })
        .then(results => results.json())
        .then(results => {
          this.setState({
            toDos: results.data,
            isLoading: false
          }, () => {
            if (cb != null) cb();
          });
        });
    })
  }

  snooze = (componentCompanyID, snooze) => {
    fetch('/api/marketing2ComponentsCompanies/snooze/', {
      method: 'PUT',
      body: JSON.stringify({
        componentCompanyID: componentCompanyID,
        snooze: snooze,
        auth0: this.props.user
      }),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        this.getMarketingToDos();
        this.closeActionsModal();
      });
  }

  markCompanyComponentComplete = (campaignCompanyID, componentCompanyID, componentID, campaignID, secID, action, auth0, linkedCampaignCompanyIDs) => {
    fetch('/api/marketing2ComponentsCompanies/', {
      method: 'PUT',
      body: JSON.stringify({
        campaignCompanyID: campaignCompanyID,
        componentCompanyID: componentCompanyID,
        componentID: componentID,
        campaignID: campaignID,
        secID: secID,
        action: action,
        auth0: auth0,
        linkedCampaignCompanyIDs: String(linkedCampaignCompanyIDs || '').split(',').map(item => parseInt(item, 10)).filter(id => Number.isInteger(id) && id > 0)
      }),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        if (!results.success) throw new Error('Unable to complete step');
        return fetch('/api/marketing2CampaignsCompanies/' + campaignCompanyID + '/complete', {
          method: 'PUT',
          headers: {
            'Authorization': 'Bearer ' + this.props.clientToken,
            'X-Database': this.context.company
          }
        });
      })
      .then(results => results.json())
      .then(results => {
        if (!results.success) throw new Error(results.error || 'Unable to update campaign completion');
        if (results.campaignComplete) {
          utilities.addToast('Campaign complete', 5, 'success');
        }
        this.getMarketingToDos();
        this.closeActionsModal();
      })
      .catch(error => {
        utilities.addToast(error.message || 'Unable to complete step', 5, 'danger');
        this.getMarketingToDos();
      });
  }

  getCurrentDateLocal = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (`0${now.getMonth() + 1}`).slice(-2); // Months are zero-indexed, add 1 to get the correct month
    const day = (`0${now.getDate()}`).slice(-2); // Add leading zero to day if necessary
    return `${year}-${month}-${day}`;
  }

  formatDueDate = (val) => {
    const endDateEpoch = new Date(String(val).substring(0, 10)).getTime();
    const todayEpoch = new Date(this.getCurrentDateLocal()).getTime();
    return endDateEpoch <= todayEpoch ? 'text-danger font-weight-bold' : '';
  }

  changeSelectedUser = (e) => {
    e.persist();
    this.setState({
      toDos: [],
      selectedUser: e.target.value
    }, () => {
      this.getMarketingToDos();
    })
  }

  getToDoRender = (obj, hideActions, hideTitles) => {
    const endDateEpoch = new Date(String(obj.endDate).substring(0, 10)).getTime();
    const todayEpoch = new Date(this.getCurrentDateLocal()).getTime();
    let isFlowValueMatching = false;
    let retHTML = <>
      {(hideTitles == null || !hideTitles) && <>
        <h6 className='my-0'>{obj.campaignCompanyTitle}</h6>
        {obj.componentIsFlow && obj.systemDemographics.filter(item => item.keyID === parseInt(obj.componentFlowConditionKey)).map(item => {
          if (item.valueID === parseInt(obj.componentFlowConditionValue)) {
            isFlowValueMatching = true;
            return (<></>)
          } else {
            return (<div className='text-danger font-weight-bold'>Actual: {item.value}</div>)
          }
        })}
        <div className='my-0'>{obj.linkedCampaignCompany !== '' ? obj.linkedCampaignCompany + ' > ' : ''} {obj.campaignName}</div>
      </>}
      {obj.componentIsFlow &&
        <>
          <Button
            size={hideActions ? "md" : "sm"}
            className='mt-2 mr-2'
            onClick={() => this.markCompanyComponentComplete(obj.campaignCompanyID, obj.componentCompanyID, obj.componentID, obj.campaignID, obj.secID, { isFlowValueMatching: isFlowValueMatching }, obj.auth0, obj.linkedCampaignCompanyIDs)}
            color="primary">
            Confirm {isFlowValueMatching ? 'Match' : 'Not Matched'}
          </Button>
        </>}
      {obj.componentIsSkip &&
        <>
          <Button
            size={hideActions ? "md" : "sm"}
            className='mt-2 mr-2'
            onClick={() => this.markCompanyComponentComplete(obj.campaignCompanyID, obj.componentCompanyID, obj.componentID, obj.campaignID, obj.secID, { skipResponse: true }, obj.auth0, obj.linkedCampaignCompanyIDs)}
            color="primary">
            Yes
          </Button>
          <Button
            size={hideActions ? "md" : "sm"}
            className='mt-2 mr-2'
            onClick={() => this.markCompanyComponentComplete(obj.campaignCompanyID, obj.componentCompanyID, obj.componentID, obj.campaignID, obj.secID, { skipResponse: false }, obj.auth0, obj.linkedCampaignCompanyIDs)}
            color="primary">
            No
          </Button>
        </>}
      {(hideActions == null || !hideActions) && <Button
        size={hideActions ? "md" : "sm"}
        className='mt-2 mr-2'
        color="primary"
        onClick={() => this.openActionsModal(obj, this.getToDoRender(obj, true, true), false)}
      >
        Actions
      </Button>}
      {!obj.componentIsSkip && !obj.componentIsFlow && (todayEpoch >= endDateEpoch) && <Button
        size={hideActions ? "md" : "sm"}
        className='mt-2 mr-2'
        onClick={() => this.markCompanyComponentComplete(obj.campaignCompanyID, obj.componentCompanyID, obj.componentID, obj.campaignID, obj.secID, null, obj.auth0, obj.linkedCampaignCompanyIDs)}
        color="success">
        Done
      </Button>}
      {obj.componentSnooze > 0 && !obj.isSnooze && !obj.componentIsDelay && <Button
        size={hideActions ? "md" : "sm"}
        className='mt-2 mr-2'
        onClick={() => this.snooze(obj.componentCompanyID, obj.componentSnooze)}
        color="warning">
        Snooze {obj.componentSnooze}d
        {/* Snooze ({obj.componentSnooze})d Day{obj.componentSnooze === 1 ? '' : 's'} */}
      </Button>}
      {/* {obj.} */}
    </>;
    return retHTML;
  }

  render() {
    const workflowOutlookInDays = this.state.users.find(item => item.Auth0 === this.state.selectedUser)?.WorkflowOutlookInDays || 3;
    return (
      <Card className='w-100 m-0'>
        <Marketing2ActionsModal
          contacts={null}
          reload={this.getMarketingToDos}
          markCompanyComponentComplete={this.markCompanyComponentComplete}
          clientToken={this.props.clientToken}
          setOpenActionsModal={(fn) => {
            this.openActionsModal = fn;
          }}
          setCloseActionsModal={(fn) => {
            this.closeActionsModal = fn;
          }}
        />
        <CardHeader className="d-flex justify-content-between align-items-center">
          <h4>Campaign To-Dos</h4>
          <PermissionWrapper {...this.props} allowedPermission="View Other User Todos" hidden={true}>
            <Col className="col-xs-5 text-right">
              <Input
                type="select"
                name="auth0"
                value={this.state.selectedUser}
                onChange={this.changeSelectedUser}
                className={this.state.selectedUser !== this.props.user ? 'border border-danger text-danger' : ''}
              >
                <option>User</option>
                {this.state.users.map(user => (
                  <option key={user.Auth0} value={user.Auth0}>{`${user['Full Name']}`}</option>
                ))}

              </Input>
            </Col>
          </PermissionWrapper>
          {this.props.icon}
        </CardHeader>
        <CardBody className='p-0'>
          <ReactTable
            data={this.state.toDos}
            isLoading={this.state.isLoading}
            columns={[
              {
                Header: 'Company',
                accessor: 'company',
                filterable: true,
                headerStyle: { textAlign: 'left' },
                minWidth: 200,
                Cell: row =>
                (<Link
                  onClick={() => localStorage.setItem('demographicsActiveTab', 7)}
                  to={{ pathname: '/demographics/' + row.original['secID'], state: {} }}>{row.original['company']}</Link>)
              },
              {
                Header: 'To-Do / Campaign',
                accessor: 'campaignCompanyTitle',
                filterable: true,
                headerStyle: { textAlign: 'left' },
                minWidth: 300,
                Cell: row => this.getToDoRender(row.original)
              },
              // {
              //   Header: 'Start Date',
              //   accessor: 'startDate',
              //   filterable: true,
              //   style: { textAlign: 'right' },
              //   headerStyle: { textAlign: 'right' },
              //   Cell: (props) => {
              //     return <>{this.props.formatDate(props.value)}</>
              //   }
              // },
              {
                Header: 'Due',
                accessor: 'endDate',
                filterable: true,
                style: { textAlign: 'right' },
                headerStyle: { textAlign: 'right' },
                Cell: (props) => {
                  return <span className={this.formatDueDate(props.value)}>{this.props.formatDate(props.value)}</span>
                }
              },


            ]}
            pageSize={this.props.pageSize}
            onPageSizeChange={this.props.setPageSize}
            showPagination={true}
            defaultFilterMethod={this.props.filterCaseInsensitive}
            noDataText={this.state.isLoading ? 'Loading...' : `No tasks due in next ${workflowOutlookInDays} day${workflowOutlookInDays === 1 ? '' : 's'}`}
          />
        </CardBody>
      </Card>
    );
  }
}

export default LandingToDos;
